import { SELECTED_WORKER_KEY } from "@/lib/api";

/** Selected worker is session-scoped UX state, not a credential. */
export const getSelectedWorkerId = () =>
  sessionStorage.getItem(SELECTED_WORKER_KEY) || "";

export const setSelectedWorkerId = (id) =>
  sessionStorage.setItem(SELECTED_WORKER_KEY, id);

export const clearSelectedWorkerId = () =>
  sessionStorage.removeItem(SELECTED_WORKER_KEY);
